<template>
  <div id="app">
    <component :is="gameState"></component>
  </div>
</template>

<script>

import Game from "./components/Game";
import IntroScreen from "./components/IntroScreen";
import { mapState } from "vuex";
import OutroScreen from "./components/OutroScreen";
import Tutorial from "./components/Tutorial";

export default {
  name: "app",
  components: {
    Game,
    IntroScreen,
    OutroScreen,
    Tutorial
  },
  computed: {
    ...mapState(["gameState", "player"]),
  }
};
</script>

<style>
</style>
